class Alert {
    constructor() {
        this.modal = document.querySelectorAll('.modal-alert');
        if (this.modal) {
            this.modal.forEach((modal) => Alert.bind(modal));
        }

        this.links = document.querySelectorAll('.js-toggle-modal');
        if (this.links) {
            this.links.forEach((link) => Alert.bindLink(link));
        }
    }

    static bindLink(link) {
        link.addEventListener('click', () => {
            const target = document.querySelector(`[data-target-id="${link.dataset.target}"]`);
            Alert.toggleModal(target);
        });
    }

    static bind(item) {
        const closemodal = item.querySelectorAll('.modal-close');
        for (let i = 0; i < closemodal.length; i++) {
            closemodal[i].addEventListener('click', () => { Alert.toggleModal(item); });
        }
    }

    static toggleModal(item) {
        item.classList.remove('hidden');
        item.classList.toggle('opacity-0');
        item.classList.toggle('pointer-events-none');
    }
}

export default Alert;
